export default "__VITE_ASSET__5f223f88__"